
const systemUser = {
    IT_ADMIN:"it-admin",
    IT_MANAGER: "it-manager",
    STAFF: "staff",
    STORE_MANAGER: "store-manager",
    SUPER_ADMIN: "super-admin",
    STORE_ADMIN:"store-admin",
    DIRECTOR:"director"
  } as const;

  type SystemUser = (typeof systemUser)[keyof typeof systemUser];

const MODULES_ACCESS_ROLES={
  ASSET_MANAGEMENT:[systemUser.IT_MANAGER,systemUser.SUPER_ADMIN],
  DISTRIBUTION: [systemUser.STORE_MANAGER,systemUser.SUPER_ADMIN],
  ASSET_ASSIGNMENT:[systemUser.STORE_MANAGER,systemUser.SUPER_ADMIN],
  MAINTENANCE: [systemUser.IT_MANAGER,systemUser.SUPER_ADMIN],
  USER_MANAGEMENT: [systemUser.IT_MANAGER,systemUser.SUPER_ADMIN],
  ASSET_DISPATCH: [systemUser.STORE_MANAGER,systemUser.SUPER_ADMIN],
  SETTINGS:[systemUser.IT_MANAGER,systemUser.SUPER_ADMIN]
}
  
export {
   type SystemUser,
   systemUser,
   MODULES_ACCESS_ROLES
}